<template>
  <v-container>
    <v-card class="elevation-3 mt-3">
      <v-container class="pt-0">
        <v-layout row wrap>
          <v-flex xs12>
            <v-toolbar color="white" text class="mt-0 pt-0 elevation-0">
              <v-toolbar-title class="subtitle-1 font-weight-medium">Editar Regra</v-toolbar-title>
            </v-toolbar>
          </v-flex>

          <v-flex xs8>
            <v-card-text>
              <v-form class="pl-12 pr-12">
                <v-layout row wrap>
                  <v-flex md12>
                    <div class="mb-12 title font-weight-regular">Detalhes</div>
                  </v-flex>
                  <v-flex md4>
                    <div class="subtitle-1 font-weight-regular blue--text text--darken-4">Nome</div>
                  </v-flex>
                  <v-flex md8>
                    <v-text-field
                      outlined
                      clearable
                      placeholder="Nome da Regra"
                      v-model="name"
                      dense
                      type="text"
                      color="teal accent-3"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md4>
                    <div class="subtitle-1 font-weight-regular blue--text text--darken-4">Módulos</div>
                  </v-flex>
                  <v-flex md8>
                    <v-layout column wrap>
                        <v-checkbox
                            class="my-0"
                            v-model="atendimento"  
                            label="Atendimento"
                            required
                        ></v-checkbox>
                        <v-checkbox
                            class="my-0"
                            v-model="medico"
                            label="Médico"
                            required
                        ></v-checkbox>
                        <v-checkbox
                            class="my-0"
                            v-model="administrador"
                            label="Administrador"
                            required
                        ></v-checkbox>
                        <v-checkbox
                            class="my-0"
                            v-model="operador"
                            label="Operador"
                            required
                        ></v-checkbox>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout class="mt-2" row wrap>
                   
                </v-layout>
                <v-layout row wrap>
                  <v-btn
                    class="body-2 white--text"
                    @click="previousStep"
                    color="primary"
                    depressed
                  >Alterar Regra</v-btn>
                </v-layout>
              </v-form>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import { mask } from "vue-the-mask";
export default {
  name: "EditRule",
  directives: { mask },
  data: () => ({
    mask: {
      telephone: "(##) #####-####"
    },
    telephone: undefined,
    name: undefined,
    avatar: undefined,
    funcao: undefined,
    cargos: ["Administrador", "Tarm", "Medico Regulador"],
    state: undefined,
    atendimento:false,
    medico:false,
    administrador:false,
    operador:false,
    stateOptions: [
      "Acre (AC)",
      "Alagoas (AL)",
      "Amapá (AP)",
      "Amazonas (AM)",
      "Bahia (BA)",
      "Ceará (CE)",
      "Distrito Federal (DF)",
      "Espírito Santo (ES)",
      "Goiás (GO)",
      "Maranhão (MA)",
      "Mato Grosso (MT)",
      "Mato Grosso do Sul (MS)",
      "Minas Gerais (MG)",
      "Pará (PA)",
      "Paraíba (PB)",
      "Paraná (PR)",
      "Pernambuco (PE)",
      "Piauí (PI)",
      "Rio de Janeiro (RJ)",
      "Rio Grande do Norte (RN)",
      "Rio Grande do Sul (RS)",
      "Rondônia (RO)",
      "Roraima (RR)",
      "Santa Catarina (SC)",
      "São Paulo (SP)",
      "Sergipe (SE)",
      "Tocantins (TO)"
    ],
    email: undefined,
    password: undefined,
    show_password: false,
    image: ""
  }),
  computed: {
    formIsValid() {
      return (
        this.name &&
        this.email &&
        this.password &&
        this.cargo &&
        this.state &&
        this.telephone
      );
    }
  },
  watch: {
    //
  },
  methods: {
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage(file) {
      //var image = new Image();
      var reader = new FileReader();
      var vm = this;

      reader.onload = e => {
        vm.image = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }
};
</script>

<style>
</style>